import { useQuery } from '@tanstack/react-query';
import remoteDbService from '@/core/database/RemoteDBService';
import { type Collection } from '@/features/collections/types/collection.types';
import { getSubdomain } from '@/lib/utils';
import { publicKeys } from '@/shared/query/queryKeys';

export const usePublicCollections = () => {
  const subdomain = getSubdomain();

  return useQuery<Collection[]>({
    queryKey: publicKeys.collections(subdomain),
    queryFn: async () => {
      if (!subdomain) {
        throw new Error('No subdomain found');
      }
      return await remoteDbService.getPublicCollections(subdomain);
    },
    enabled: !!subdomain, // Only run query if we have a subdomain
  });
};
